import moment from 'moment';

export const getTimestampStr = () => moment().format('YYYY-MM-DD hh:mm A');
